import { blobToFile } from './blobToFile'

export const convertWebPToJpeg = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        reject(new Error('Canvas context is not supported'))
        return
      }
      ctx.drawImage(img, 0, 0)
      canvas.toBlob(
        (blob) => {
          if (blob)
            resolve(blobToFile(blob, file.name.replace('.webp', '.jpg')))
          else reject(new Error('Failed to convert WebP to JPEG'))
        },
        'image/jpeg',
        0.9,
      ) // 0.9 - качество JPEG
    }
    img.onerror = reject
    img.src = url
  })
}
